import pawanputraLogo from 'assets/images/logo/Pawanputra-logo-new.png';

export type ClientBranding = {
  appName: string;
  companyName: string;
  logo: string;
  footerLogo: string;
  lableBottomLogo: boolean;
  sidebarLogoExpanded: string;
  sidebarLogoCollapsed: string;
  logoDark?: string;
  sidebarLogoExpandedDark?: string;
  favicon: string;
};

export type ClientInvoice = {
  legalCompanyName: string;
  gstNumber: string;
  registeredOffice: string;
  supportContact: string;
  invoiceSignImage?: string;
};

export type ClientConfig = {
  clientKey: string;
  branding: ClientBranding;
  invoice: ClientInvoice;
  paymentGateway: string;
  wocomAppName: string;
  shopifyURL: string;
};

const defaultLogo = pawanputraLogo;
const defaultFavicon = '/favicon.svg';

export const clientConfigObj: Record<string, ClientConfig> = {
  pawanputra: {
    clientKey: 'pawanputra',
    branding: {
      appName: 'Pawanputra Courier and Logistics',
      companyName: 'Pawanputra Courier and Logistics',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'Pawanputra Courier and Logistics',
      gstNumber: '',
      registeredOffice: '',
      supportContact: '',
      invoiceSignImage: '/client-assets/pawanputra/invoice-sign.png'
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  },
  jpglogistics: {
    clientKey: 'jpglogistics',
    branding: {
      appName: 'JPG Logistics',
      companyName: 'JPG Logistics',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'JPG Logistics',
      gstNumber: '',
      registeredOffice: '',
      supportContact: '',
      invoiceSignImage: '/client-assets/jpg/invoice-sign.png'
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  },
  cargodham: {
    clientKey: 'cargodham',
    branding: {
      appName: 'CargoDham',
      companyName: 'CargoDham',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'CargoDham',
      gstNumber: '',
      registeredOffice: '',
      supportContact: '',
      invoiceSignImage: '/client-assets/cargodham/invoice-sign.png'
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  },
  ronik: {
    clientKey: 'ronik',
    branding: {
      appName: 'Ronik Courier Service',
      companyName: 'Ronik Courier Service',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'Ronik Courier Service',
      gstNumber: '',
      registeredOffice: '',
      supportContact: '',
      invoiceSignImage: '/client-assets/ronik/invoice-sign.png'
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  },
  shipcave: {
    clientKey: 'shipcave',
    branding: {
      appName: 'ShipCave',
      companyName: 'ShipCave',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'ShipCave',
      gstNumber: '',
      registeredOffice: '',
      supportContact: '',
      invoiceSignImage: '/client-assets/shipcave/invoice-sign.png'
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  },
  shiproute: {
    clientKey: 'shiproute',
    branding: {
      appName: 'ShipRoute',
      companyName: 'ShipRoute',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'ShipRoute',
      gstNumber: '',
      registeredOffice: '',
      supportContact: '',
      invoiceSignImage: '/client-assets/shiproute/invoice-sign.png'
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  },
  rapidpost: {
    clientKey: 'rapidpost',
    branding: {
      appName: 'RapidPost',
      companyName: 'RAPIDLOG TECHNOLOGIES PVT LTD',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'RAPIDLOG TECHNOLOGIES PVT LTD',
      gstNumber: '',
      registeredOffice: 'HS Hotelwala Compound, Behrampura, Ahmedabad 380028',
      supportContact: '+91 9898956554',
      invoiceSignImage: '/client-assets/rapidpost/invoice-sign.png'
    },
    paymentGateway: 'razorpay',
    wocomAppName: 'rapidpost',
    shopifyURL: ''
  },
  shipdart: {
    clientKey: 'shipdart',
    branding: {
      appName: 'Shipdartexpress',
      companyName: 'Shipdartexpress',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'SWIFT DISPATCH PRO PRIVATE LIMITED',
      gstNumber: '',
      registeredOffice: '',
      supportContact: '',
      invoiceSignImage: '/client-assets/shipdart/invoice-sign.png'
    },
    paymentGateway: 'razorpay',
    wocomAppName: 'Shipdartexpress',
    shopifyURL: ''
  },
  yawlogix: {
    clientKey: 'yawlogix',
    branding: {
      appName: 'Yawlogix',
      companyName: 'YAWLOGIX A UNIT OF YAWAN EXPRESS SERVICES PVT LTD',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'YAWLOGIX A UNIT OF YAWAN EXPRESS SERVICES PVT LTD',
      gstNumber: '08AABCY8170D1Z8',
      registeredOffice: 'Samridhi Nagar, Special, borkheda Baran Road, Kota - 324001',
      supportContact: '+91 82905 99991',
      invoiceSignImage: '/client-assets/shipdart/invoice-sign.png'
    },
    paymentGateway: 'razorpay',
    wocomAppName: 'Shipdartexpress',
    shopifyURL: ''
  }
};

export const clientConfigPath = {
  pawanputra: '/client-configs/pawanputra.json',
  jpglogistics: '/client-configs/jpglogistics.json',
  cargodham: '/client-configs/cargodham.json',
  ronik: '/client-configs/ronik.json',
  shipcave: '/client-configs/shipcave.json',
  shiproute: '/client-configs/shiproute.json',
  rapidpost: '/client-configs/rapidpost.json',
  shipdart: '/client-configs/shipdart.json',
  yawlogix: '/client-configs/yawlogix.json'
} as const;

export const defaultClientConfig = clientConfigObj.pawanputra;